/* koréos C pages (build agent P, 2026-10-16): collection toolbar + load more, PDP (add-to-bag price, gallery counter,
   routine builder), Originals scent switch, filter sheet count. Plain JS, no dependencies; each part is optional. */
(() => {
  if (window.kcPages) return;
  window.kcPages = true;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const money = (cents) => {
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };
  const ready = (fn) => (document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn());

  /* Add to bag label everywhere Hyper rewrites it after a variant change */
  const setStrings = () => { if (window.FoxTheme && FoxTheme.variantStrings) FoxTheme.variantStrings.addToCart = 'Add to bag'; };

  /* ---------- collection / search ---------- */
  function clamp() {
    $$('[data-kc-clamp]').forEach((el) => {
      const inner = el.firstElementChild; const btn = $('.kc-chd__more', el);
      if (!inner || !btn) return;
      if (inner.scrollHeight > inner.clientHeight + 4) btn.hidden = false;
      btn.addEventListener('click', () => {
        const open = el.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open); btn.textContent = open ? 'Show less' : 'Read more';
      });
    });
  }
  function filterPills() {
    document.addEventListener('click', (e) => {
      const b = e.target.closest('[data-kc-filter]');
      if (!b) return;
      const drawer = document.getElementById('FacetDrawer');
      if (!drawer || typeof drawer.show !== 'function') return;
      drawer.show(b);
      const idx = b.getAttribute('data-kc-filter');
      setTimeout(() => {
        $$('#DrawerFacetFiltersContainer details[data-filter]').forEach((d) => {
          const on = d.dataset.index === idx;
          if (on) { d.open = true; d.setAttribute('aria-expanded', 'true'); d.scrollIntoView({ block: 'start' }); }
        });
      }, 60);
    });
    // "Show N products" follows the live count after each facet update
    document.addEventListener('collection:rerendered', () => {
      const c = document.getElementById('ProductCount');
      const n = c && (c.textContent.match(/\d[\d,]*/) || [])[0];
      $$('[data-kc-apply]').forEach((el) => { if (n) el.textContent = `Show ${n} ${n === '1' ? 'product' : 'products'}`; });
    });
  }
  function loadMore() {
    document.addEventListener('click', async (e) => {
      const a = e.target.closest('[data-kc-more]');
      if (!a) return;
      e.preventDefault();
      if (a.classList.contains('is-loading')) return;
      a.classList.add('is-loading'); a.setAttribute('aria-busy', 'true');
      const list = document.getElementById('ProductsList');
      const box = a.closest('.kc-loadmore');
      const sec = a.closest('.shopify-section');
      const url = new URL(a.href, location.origin);
      if (sec) url.searchParams.set('section_id', sec.id.replace('shopify-section-', ''));
      try {
        const html = await (await fetch(url)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const first = $$('#ProductsList > .f-column', doc);
        first.forEach((c) => list.appendChild(c));
        const nb = $('.kc-loadmore', doc);
        if (nb && box) box.replaceWith(nb); else if (box) box.remove();
        const link = first[0] && first[0].querySelector('a[href]');
        if (link) link.focus({ preventScroll: true });
      } catch (err) { location.href = a.href; }
    });
  }

  /* ---------- product page ---------- */
  function atcPrice() {
    const sync = () => {
      $$('product-info[id^="MainProduct"]').forEach((pi) => {
        const p = $('[data-kc-price]', pi);
        const t = $('[data-kc-atc-price]', pi);
        if (p && t) t.textContent = p.textContent.trim();
      });
    };
    sync();
    document.addEventListener('variant:changed', () => setTimeout(sync, 30));
    $$('[id^="price-"]').forEach((el) => new MutationObserver(sync).observe(el, { childList: true, subtree: true }));
  }
  function galleryCount() {
    $$('.kc-pdp media-gallery').forEach((g) => {
      const items = $$('.product__media-item', g);
      if (items.length < 2) return;
      const ct = document.createElement('span');
      ct.className = 'kc-gal-ct'; ct.setAttribute('aria-hidden', 'true');
      ct.textContent = `1 / ${items.length}`;
      const wrap = $('.product__media-gallery-viewer-wrap', g) || g;
      wrap.appendChild(ct);
      const io = new IntersectionObserver((ents) => {
        ents.forEach((en) => { if (en.isIntersecting && en.intersectionRatio > .6) ct.textContent = `${items.indexOf(en.target) + 1} / ${items.length}`; });
      }, { threshold: [.6] });
      items.forEach((i) => io.observe(i));
    });
  }
  function stickyAtc() {
    const bar = $('.sticky-atc-bar'); const btn = $('.kc-pdp .product-form__submit');
    if (!bar || !btn) return;
    bar.classList.add('kc-satc');
    new IntersectionObserver(([en]) => {
      bar.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0);
    }).observe(btn);
  }
  async function routine() {
    const sec = $('[data-kc-routine]');
    if (!sec) return;
    const rows = $('.kc-rt__rows', sec);
    const base = sec.dataset.url;
    const grab = async (intent) => {
      try {
        const html = await (await fetch(base + (intent ? `&intent=${intent}` : ''))).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return $$('.kc-rt__fetched .kc-rrow', doc);
      } catch (e) { return []; }
    };
    const limit = +sec.dataset.limit || 4;
    // QA B2: complementary steps only — one product per routine step, never the page product's own step
    // (no other scents / shades / packs of the same thing). Complementary first, own-brand picks, then related.
    const used = new Set([sec.dataset.step || '']);
    const ids = new Set($$('.kc-rrow [data-id]', rows).map((i) => i.dataset.id));
    // final-fix 2026-10: exact department steps from kc-routine.liquid (skin / makeup + lip / hair / body; night products
    // carry no sunscreen). A row whose step is not on the list is never shown.
    const allow = (sec.dataset.allow || '').split(',').filter(Boolean);
    if (!allow.length) { sec.closest('.shopify-section')?.remove(); return; }
    let got = [];
    const take = (list) => list.forEach((r) => {
      if (got.length >= limit) return;
      const step = r.dataset.step || '';
      const inp = $('[data-id]', r); if (!inp) return;
      if (!step || used.has(step) || ids.has(inp.dataset.id)) return;
      if (!allow.includes(step)) return;
      // r4: never an SPF / day step and a night item (retinoid, bakuchiol, overnight, sleeping, wrapping) in one routine
      const isSun = step === 'sunscreen' || r.hasAttribute('data-day');
      const isNight = r.hasAttribute('data-night');
      if ((isSun && night) || (isNight && day)) return;
      used.add(step); ids.add(inp.dataset.id); got.push(r);
      if (isSun) day = true;
      if (isNight) night = true;
    });
    let night = sec.hasAttribute('data-night');
    let day = sec.hasAttribute('data-day');
    const comp = await grab('complementary');
    const tpl = $('template[data-kc-rt-extra]', sec);
    const extra = tpl ? $$('.kc-rrow', tpl.content) : [];
    // a sunscreen in the candidate pool wins over night items
    if (!night && [...comp, ...extra].some((r) => allow.includes(r.dataset.step || '') && (r.dataset.step === 'sunscreen' || r.hasAttribute('data-day')))) day = true;
    take(comp);
    if (got.length < limit) take(extra);
    if (got.length < limit) take(await grab('related'));
    if (!got.length) { sec.closest('.shopify-section')?.remove(); return; }
    got.forEach((r) => rows.appendChild(document.importNode(r, true)));
    $$('.kc-rrow', rows).sort((a, b) => (+a.dataset.order) - (+b.dataset.order)).forEach((r, i) => {
      rows.appendChild(r); $('.kc-rrow__n', r).textContent = String(i + 1).padStart(2, '0');
    });
    sec.hidden = false;
    const btn = $('[data-kc-rt-add]', sec);
    const upd = () => {
      const on = $$('[data-kc-rt-item]:checked', sec);
      const tot = on.reduce((s, i) => s + (+i.dataset.price), 0);
      $('[data-kc-rt-n]', sec).textContent = on.length;
      $('[data-kc-rt-word]', sec).textContent = on.length === 1 ? 'product' : 'products';
      $('[data-kc-rt-t]', sec).textContent = money(tot);
      $('[data-kc-rt-pts]', sec).textContent = Math.floor(tot / 100) * 2;
      $('[data-kc-rt-free]', sec).textContent = tot >= 4000 ? 'ships free' : `${money(4000 - tot)} to free shipping`;
      btn.textContent = on.length ? `Add ${on.length} to bag · ${money(tot)}` : 'Pick at least one';
      btn.disabled = !on.length;
      $$('.kc-rrow', sec).forEach((r) => r.classList.toggle('is-off', !$('[data-kc-rt-item]', r).checked));
    };
    sec.addEventListener('change', upd); upd();
    btn.addEventListener('click', async () => {
      const items = $$('[data-kc-rt-item]:checked', sec).map((i) => ({ id: +i.dataset.id, quantity: 1 }));
      if (!items.length) return;
      btn.classList.add('is-loading'); btn.disabled = true;
      try {
        const r = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        const j = await r.json();
        if (j.status) throw new Error(j.description || j.message);
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
      } catch (err) { alert(err.message || 'Could not add to bag. Please try again.'); }
      btn.classList.remove('is-loading'); upd();
    });
  }

  /* ---------- Originals hub: Pumpoo scent switch ---------- */
  function scents() {
    $$('.kc-scents').forEach((grp) => {
      const stage = grp.closest('.kc-stage');
      grp.addEventListener('click', (e) => {
        const b = e.target.closest('.kc-scent');
        if (!b) return;
        $$('.kc-scent', grp).forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
        stage.style.setProperty('--stage', b.dataset.stage);
        const hero = $('[data-kc-scent-hero]', stage);
        if (hero) { hero.href = b.dataset.url; const img = $('img', hero); if (img) { img.removeAttribute('srcset'); img.src = b.dataset.img; img.alt = b.textContent.trim(); } }
        const nm = $('[data-kc-scent-name]', stage); if (nm) nm.textContent = b.dataset.name;
        const nt = $('[data-kc-scent-notes]', stage);
        if (nt) { nt.textContent = b.dataset.notes; nt.parentElement.hidden = !b.dataset.notes; }
        $$('.kc-scent-add', stage).forEach((f) => { f.hidden = f.id !== b.dataset.target; });
      });
    });
  }

  /* ---------- mobile PDP: keep the Inbox chat bubble off the title / price / Add to bag (QA M5) ---------- */
  function chatGuard() {
    if (!$('.kc-pdp') || !('IntersectionObserver' in window)) return;
    const html = document.documentElement;
    const mq = window.matchMedia('(max-width: 767px)');
    const watch = $$('.kc-pdp .product__title, .kc-pdp .product__block--price, .kc-pdp .product__block--buy_buttons');
    const seen = new Set();
    const sync = () => html.classList.toggle('kc-chat-hide', mq.matches && seen.size > 0);
    const io = new IntersectionObserver((es) => { es.forEach((e) => (e.isIntersecting ? seen.add(e.target) : seen.delete(e.target))); sync(); });
    watch.forEach((el) => io.observe(el));
    mq.addEventListener && mq.addEventListener('change', sync);
    const bar = $('.kc-satc');
    if (bar) {
      const lift = () => { html.classList.toggle('kc-chat-lift', bar.classList.contains('sticky-atc-bar--show') || bar.classList.contains('is-on')); html.style.setProperty('--kc-satc-h', (bar.offsetHeight || 72) + 'px'); };
      new MutationObserver(lift).observe(bar, { attributes: true, attributeFilter: ['class'] }); lift();
    }
  }

  ready(() => {
    chatGuard();
    setStrings(); document.addEventListener('page:loaded', setStrings);
    window.addEventListener('load', setStrings);
    clamp(); filterPills(); loadMore();
    atcPrice(); galleryCount(); stickyAtc(); routine();
    scents();
  });
})();
